import moment from 'moment'
import { pluralize } from 'humanize-plus'
import React,
{ Fragment } from 'react'

import {
  Div,
  InlineWarning
} from '@driftt/tide-core'
import {
  OPERATOR_LABELS_BY_TYPE,
  OPERATORS
} from 'components/ContactFilterBuilder/constants/Operators'

import './style.css'

const formatMulti = (values, type) => {
  const formattedValue = `${values.length} items`
  let warning
  switch (type) {
  case 'STRING':
    break
  case 'NUMERIC':
    if (values.some(v => isNaN(v) && v.includes(','))) {warning = 'Invalid entry: remove commas'}
    else if (values.some(v => isNaN(v))) {warning = 'Invalid entry: please use numeric values'}
    break
  default:
  }

  return {
    value: formattedValue,
    warning: warning
  }
}

const formatDate = (value, operator) => {
  let formattedValue
  if (operator === 'RELATIVE_DATE_FILTER') {
    const from = value.rawFromValue
    const to = value.rawToValue

    const timeUnit = value.timeUnit
    const timeUnitFormatted = timeUnit.toLowerCase()

    const fromWithUnit = `${from} ${timeUnitFormatted}`
    const toWithUnit = `${to} ${timeUnitFormatted}`

    const isFromPastToNow = to === 0
    if (isFromPastToNow) {
      formattedValue = `is within the last ${fromWithUnit}`
    }

    const isPriorToGivenTime = from === null
    if (isPriorToGivenTime) {
      formattedValue = `is before ${toWithUnit} ago`
    }

    const fallback = `is before ${toWithUnit} and after ${fromWithUnit}`
    formattedValue = fallback
  } else {formattedValue = moment(Number(value) || value).format('MM/DD/YYYY')}

  return { value: formattedValue }
}

const valueFormatter = ({
  value,
  operator,
  type
}) => {
  if ([OPERATORS.IS_PRESENT, OPERATORS.IS_NOT_PRESENT].includes(operator)) {return { value: '' }}
  else if (Array.isArray(value)) {return formatMulti(value, type)}
  else if (['DATE', 'DATETIME'].includes(type)) {return formatDate(value, operator)}
  else {return { value: String(value) }}
}

const resolveRelativeDateText = (value) => {
  const relativeDays = value.rawFromValue ? value.rawFromValue : value.rawToValue

  return `${value.rawFromValue ? 'after' : 'before'} ${relativeDays} ${pluralize(relativeDays, 'day')} ago`
}

const SegmentValue = ({
  value,
  type,
  operator,
  subType,
  onClick
}) => {
  if (type === 'NUMERIC' && value == null) {
    value = 0
  }

  const formattedValue = valueFormatter({
    value,
    operator,
    type
  })

  const isAbsoluteDateOperator = (operator === "IS_BEFORE" && subType === 'events')||
                                 (operator === "IS_AFTER" && subType === 'events')

  const isRelativeDateOperator = (operator === "RELATIVE_DATE_FILTER" && subType  === 'events') ||
                                 (operator === 'IS_AFTER_RELATIVE' && subType === 'events') ||
                                 (operator === 'IS_BEFORE_RELATIVE' && subType === 'events')


  const filterValue = isAbsoluteDateOperator ? (
    <>
      {value.checkForMostRecent ? 'Last' : 'First'}&nbsp;
      {OPERATOR_LABELS_BY_TYPE[subType][operator]}&nbsp;
      {moment(value.value).format('MM/DD/YYYY')}
    </>
  ) :
    (isRelativeDateOperator ?
     <>
      {value.checkForMostRecent ? 'Last occurred' : 'First occurred'}&nbsp;
      {resolveRelativeDateText(value)}
     </> :
    <>
      {OPERATOR_LABELS_BY_TYPE[subType][operator]} {formattedValue.value}
    </>
    )
  return (
    <Fragment>
      <Div className="filter-builder--filter-value" onClick={onClick}>
        {filterValue}
      </Div>
      {formattedValue.warning && <InlineWarning type="danger" className="invalid-filter-warning"
        copy={formattedValue.warning} />}
    </Fragment>
  )
}

export default SegmentValue
